export const COMPANY_VISIBILITY = {
    INTERNAL: 'INTERNAL',
    PUBLIC: 'PUBLIC',
} as const;

export type CompanyVisibilityType = (typeof COMPANY_VISIBILITY)[keyof typeof COMPANY_VISIBILITY];

// Reserved for unassessed company importance; sorts after every known score.
export const COMPANY_IMPORTANCE_UNKNOWN = 127;
export const COMPANY_IMPORTANCE_UNKNOWN_LABEL = 'UNKNOWN';

class CompanyC {

    static LINK_PROPS_MAP = {
        investorRelationsLink: "Investor Relations", reportsLink: "Reports",
        reportsHYLink: "Reports Half-Year", reportsQLink: "Reports Quarterly",
        presentationsLink: "Presentations",
        pressReleasesLink: "Press Releases / News",
        financialCalendarLink: "Financial Calendar"
    }
}

export default CompanyC
